import type {BulkUpdateErrorKey} from 'api/types';
import {BulkUpdateErrorKeys} from 'api/types';

export const isBulkUpdateErrorKey = (
  value: unknown,
): value is BulkUpdateErrorKey => {
  return !!value && BulkUpdateErrorKeys.includes(value as BulkUpdateErrorKey);
};
